import { render, staticRenderFns } from "./StudentActivityTableProcessCell.vue?vue&type=template&id=cb5ee1d4&scoped=true&"
import script from "./StudentActivityTableProcessCell.vue?vue&type=script&lang=ts&"
export * from "./StudentActivityTableProcessCell.vue?vue&type=script&lang=ts&"
import style0 from "./StudentActivityTableProcessCell.vue?vue&type=style&index=0&id=cb5ee1d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5ee1d4",
  null
  
)

export default component.exports